import validators from '../../../../utilities/validators';

const validator = (isCreation = true) =>
    validators.compose(
        validators.requiredNonEmptyString('displayName'),
        validators.requiredString('currency'),
        validators.requiredString('apiKey'),
        validators.only(() => isCreation, validators.requiredString('encryptionKey')),
        validators.requiredString('paymentEndpoint')
    );

export default validator;
